import { format, startOfWeek, subWeeks } from 'date-fns';
import type { DateRange } from 'react-day-picker';

const DEFAULT_WEEKS = 12;

export type OverviewQuery = {
	dateFrom?: string;
	dateTo?: string;
};

export function defaultOverviewRange(): DateRange {
	const today = new Date();
	return { from: startOfWeek(subWeeks(today, DEFAULT_WEEKS - 1), { weekStartsOn: 1 }), to: today };
}

function isoDay(date: Date | undefined): string | undefined {
	return date ? format(date, 'yyyy-MM-dd') : undefined;
}

export function overviewQueryOf(range: DateRange | undefined): OverviewQuery {
	return { dateFrom: isoDay(range?.from), dateTo: isoDay(range?.to ?? range?.from) };
}
